export function prependArticle(input: string): string {
    if (!input) {
        return '';
    }
    const vowels = new Set(['a', 'e', 'i', 'o', 'u']);
    const firstLetter = input.trim().charAt(0).toLowerCase();

    return vowels.has(firstLetter) ? `an ${input}` : `a ${input}`;
}
